<script setup>
import { ref, watch } from "vue";
import WrCrossIcon from "../atoms/icons/WrCrossIcon.vue";
import WrOfficialPartnerCard from "./WrOfficialPartnerCard.vue";
const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
    required: true,
  },
});
const emit = defineEmits(["close"]);
const visible = ref(props.isOpen);

const content = [
  {
    icon: "/images/officialCardVue.webp",
    iconBG: "bg-[#41B983]",
    imgHeight: 45,
    imgWidth: 55,
    name: "Vue",
    text: "We are thrilled to be the official partner for Vue. We are experienced in building complex apps with the performant & versatile library Vue.",
    buttons: [
      {
        text: "Services",
        link: "/services/frameworks/vuejs-development-services",
      },
      {
        text: "Learn More",
        link: "https://vuejs.org/partners/webreinvent.html",
      },
    ],
    alt: "Vue Icon",
    imgPosition: "left",
    appendClass:
      "bg-transparent border border-[#41B983] hover:text-white hover:bg-[#41B983] hover:text-white hover:border-transparent",
  },
  {
    icon: "/images/nuxtjs-white.webp",
    iconBG: "bg-[#41B983]",
    imgHeight: 36,
    imgWidth: 55,
    name: "Nuxt",
    text: "We are official Nuxt partner and are deeply involved in the Nuxt development community and can provide you with the best quality service.",
    buttons: [
      {
        text: "Services",
        link: "/services/frameworks/nuxtjs-development-services",
      },
      {
        text: "Learn More",
        link: "https://nuxt.com/support/agencies/webreinvent",
      },
    ],
    alt: "Nuxt Icon",
    imgPosition: "right",
    appendClass:
      "bg-transparent border border-[#41B983] hover:text-white hover:bg-[#41B983] hover:text-white hover:border-transparent",
  },
];

watch(
  () => props.isOpen,
  (newVal) => {
    visible.value = newVal;
  }
);

watch(visible, (newVal) => {
  if (!newVal) {
    emit("close");
  }
});

const handleClose = () => {
  visible.value = false;
};
</script>

<template>
  <div class="card flex justify-center z-30">
    <Dialog
      v-model:visible="visible"
      :modal="true"
      :dismissableMask="true"
      closeOnEscape
      closable
      unstyled
      class="w-[90vw] md:w-[90vw] max-h-[90vh]"
      :pt="{
        root: {
          class:
            'relative dark:bg-[linear-gradient(92.4deg,_rgba(53,9,91)_6.22%,rgba(63,0,119)_93.78%)] bg-[#fff] rounded-xl',
        },
        headerActions: {
          class: 'hidden',
        },
        mask: {
          class: 'bg-[hsla(0,_0%,_4%,_0.7)]',
        },
      }"
    >
      <template #header>
        <div class="absolute -top-3 -right-3 z-40">
          <button @click="handleClose">
            <WrCrossIcon
              class="text-white p-1 bg-[#5f4ca4] rounded-full border-2"
            />
          </button>
        </div>
      </template>
      <div class="h-[90vh] overflow-y-auto">
        <div
          class="w-full p-5 md:p-10 flex items-center flex-col justify-center gap-5 text-center"
        >
          <h1>
            <WrGradientText text="We're the Official Partners" />
          </h1>
          <p class="text-lg text-center">
            We are proud to mention that we're the official partners of
            <strong> Laravel, Vue, and Nuxt </strong>
            - All of them are the most popular web frameworks currently
            available.
          </p>
        </div>
        <div class="px-5 md:px-10 pb-5 md:pb-10 space-y-6">
          <div class="w-full">
            <WrOfficialPartnerCard
              :content="{
                icon: '/images/officialCardLaravel.webp',
                imgHeight: 56,
                imgWidth: 55,
                iconBG: 'bg-[#FE312A]',
                name: 'Laravel',
                text: 'We\'re honored to be an official partner of Laravel. We\'re here to bring you brilliant software and the support you need.',
                buttons: [
                  {
                    text: 'Development Services',
                    link: '/services/frameworks/laravel-development-services',
                  },
                  {
                    text: 'Maintenance Services',
                    link: '/services/maintenance-services/laravel',
                  },
                  {
                    text: 'Learn More',
                    link: 'https://partners.laravel.com/partners/webreinvent',
                  },
                ],
                alt: 'Laravel Icon',
                imgPosition: 'left',
                appendClass:
                  'border-[#FE312A] border bg-transparent hover:bg-[#FE312A] hover:text-white hover:border-transparent',
              }"
            />
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-10 w-full">
            <WrOfficialPartnerCard
              v-for="card in content"
              :content="{
                icon: card.icon,
                alt: card.alt,
                iconBG: card.iconBG,
                name: card.name,
                text: card.text,
                buttons: card.buttons,
                imgPosition: card.imgPosition,
                appendClass: card.appendClass,
                imgHeight: card.imgHeight,
                imgWidth: card.imgWidth,
              }"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
